// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-padding {
  padding: 0 !important;
  margin: 0 !important;
}

.mandatory {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/work-item-edit/work-item-edit.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,oBAAA;AACJ;;AAEE;EACE,iBAAA;AACJ","sourcesContent":[".no-padding {\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  \n  .mandatory {\n    font-weight: bold;\n    // color: var(--ion-color-danger); /* Optional: highlight the label */\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
